module.exports = __webpack_public_path__ + "static/media/mu.81aeb120.png";